module.exports = __webpack_public_path__ + "static/save-time-plumber-mobile-e1f7a539863e7c9fa4c16ae480f83f52.jpg";